import { render } from "./GeneralJournal.vue?vue&type=template&id=2b689965"
import script from "./GeneralJournal.vue?vue&type=script&lang=js"
export * from "./GeneralJournal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__